import { FxIdDomainSettingsUrlOpenMethod } from "@/api/gen";
import { appStore } from "@/app/store/appStore";

const DEFAULT_PP_URL = "https://wishlistgames.net/legal/privacy";
const DEFAULT_TOS_URL = "https://wishlistgames.net/legal/tos";

export const useTosPPLink = () => {
	const gameConfig = appStore((state) => state.gameConfig);

	const gameConfigPPUrl = gameConfig.PpUrl;
	const gameConfigPpUrlOpenMethod = gameConfig.PpUrlOpenMethod;
	const gameConfigTosUrl = gameConfig.TosUrl;
	const gameConfigTosUrlOpenMethod = gameConfig.TosUrlOpenMethod;

	return {
		ppUrl: gameConfigPPUrl ? gameConfigPPUrl : DEFAULT_PP_URL,
		ppUrlOpenMethod: gameConfigPpUrlOpenMethod ? gameConfigPPUrl : FxIdDomainSettingsUrlOpenMethod.Unspecified,
		tosUrl: gameConfigTosUrl ? gameConfigTosUrl : DEFAULT_TOS_URL,
		tosUrlOpenMethod: gameConfigTosUrlOpenMethod
			? gameConfigTosUrlOpenMethod
			: FxIdDomainSettingsUrlOpenMethod.Unspecified
	};
};
